import { render, staticRenderFns } from "./FabricSelector.vue?vue&type=template&id=440f1eb7&scoped=true"
import script from "./FabricSelector.vue?vue&type=script&lang=ts"
export * from "./FabricSelector.vue?vue&type=script&lang=ts"
import style0 from "./FabricSelector.vue?vue&type=style&index=0&id=440f1eb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440f1eb7",
  null
  
)

export default component.exports